import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e12846ac&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e12846ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12846ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e12846ac')) {
      api.createRecord('e12846ac', component.options)
    } else {
      api.reload('e12846ac', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e12846ac&scoped=true&", function () {
      api.rerender('e12846ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IP21DnjwIKQZ/JS/comp/PopupBox.vue"
export default component.exports